import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlPurchaseVoid } from './connectionData.tsx'

const usePurchaseVoid = () => {
  const [errorPurchaseVoid, setErrorPurchaseVoid] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const purchaseVoid = async (_id: string, cause: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlPurchaseVoid()
      const res = await customPost<{ message: string }>(apiUrl, { _id, cause, by })
      setErrorPurchaseVoid(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPurchaseVoid(err)
      } else {
        setErrorPurchaseVoid(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPurchaseVoid, loading, purchaseVoid }
}
export default usePurchaseVoid
